/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterOccupancyLossCostRatesDto
 */
export interface FilterOccupancyLossCostRatesDto {
    /**
     * List of occupancy names to filter by
     * @type {Array<string>}
     * @memberof FilterOccupancyLossCostRatesDto
     */
    occupancyNames?: Array<string>;
}

/**
 * Check if a given object implements the FilterOccupancyLossCostRatesDto interface.
 */
export function instanceOfFilterOccupancyLossCostRatesDto(value: object): value is FilterOccupancyLossCostRatesDto {
    return true;
}

export function FilterOccupancyLossCostRatesDtoFromJSON(json: any): FilterOccupancyLossCostRatesDto {
    return FilterOccupancyLossCostRatesDtoFromJSONTyped(json, false);
}

export function FilterOccupancyLossCostRatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterOccupancyLossCostRatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'occupancyNames': json['occupancyNames'] == null ? undefined : json['occupancyNames'],
    };
}

export function FilterOccupancyLossCostRatesDtoToJSON(json: any): FilterOccupancyLossCostRatesDto {
    return FilterOccupancyLossCostRatesDtoToJSONTyped(json, false);
}

export function FilterOccupancyLossCostRatesDtoToJSONTyped(value?: FilterOccupancyLossCostRatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occupancyNames': value['occupancyNames'],
    };
}

